<template>
  <div class="content">
    <div class="banner"><img :src="$t('news.banner')" ></div>
    <div class="newsList">
        <div class="newsItem" v-for="(item,index) in $t('news.newsList')" :key="index" @mouseenter="mouseNews(index)" @mouseleave="mouseClass = false" :class="(mouseClass && newsIndex == index) ? 'bg_f8' : ''">
            <div class="itemCon" @click="jumpDetail(item)">
                <div class="dateBox">
                    <span>{{item.day}}</span>
                    <p></p>
                    <span>{{item.month}}</span>
                </div>
                <div :class="$vuetify.breakpoint.mobile ? 'mNewContent newContent' : 'newContent'">
                    <p :class="(mouseClass && newsIndex == index) ? 'color_red newsTitle' : 'newsTitle'">{{item.title}}</p>
                    <p v-html="item.content"></p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
 import newsApi from '../../api/news'
 import izh from "../../i18n/zh";
 import ien from "../../i18n/en";
  export default {
    name: 'market',
    data: () => ({
      mouseClass:false,
      newsIndex:''
    }),
    methods:{
        mouseNews(index){
            this.mouseClass = true;
            this.newsIndex = index;
        },
        jumpDetail(item){
            if( item.externalLink ){
                window.open(item.externalLink,'_blank')
            }else{
                this.$router.push( { path:'/newsDetail', query: { id: item.contentId } } )
            }

        },
        async getDate(){
            let { data: dataBanner } = await newsApi.getBanner();
            let { data: newData } = await newsApi.getNewsList()
            let newsList = newData[0].contents;
            let zhNews=[],enNews=[];
            newsList.forEach(item => {
                let m,d;
                m = item.contentDate?.substring(item.contentDate.indexOf('-')+1,item.contentDate?.indexOf('-')+3);
                d = item.contentDate?.substring(item.contentDate.lastIndexOf('-')+1,item.contentDate?.lastIndexOf('-')+3)
                zhNews.push({ contentId: item.contentId, title:item.contentNameZhCn,externalLink:item.externalLink, content: item.contentZhCn , month: m, day: d});
                enNews.push({ contentId: item.contentId, title:item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn,externalLink:item.externalLink, content: item.contentEnUs ? item.contentEnUs : item.contentZhCn , month: m, day: d});
            });
            izh.news = {
                banner: dataBanner.picturesZhCn,
                newsList: zhNews
            };
            ien.news = {
                banner: dataBanner.picturesEnUs ? dataBanner.picturesEnUs : dataBanner.picturesZhCn,
                newsList: enNews
            }
        }
    },
    created(){
      this.getDate();
    }
  }
</script>
<style lang="scss" scoped>
    .banner{
        width: 100vw;
        img{
            width: 100%;
        }
    }
    .mNewContent{
        .newsTitle{
            font-size: 2rem!important;
        }
    }
    .newsList{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        overflow: hidden;
        .newsItem{
            width: 100%;
            padding: 20px 0 20px 0;
            cursor: pointer;
            .itemCon{
                width: 70%;
                margin-left: 15%;
                display: flex;
            }
            .dateBox{
                width: 40px;
                height: 50px;
                font-size: 18px;
                position: relative;
                :first-child{
                    color: #c7c7c7;
                }
                p{
                    height: 1px;
                    width: 40px;
                    background: red;
                    transform: rotate(-45deg) translateY(-6px);
                }
                :last-child{
                    color: red;
                    font-weight: 600;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
            }
            .newContent{
                margin-left: 20px;
            }
            .newsTitle{
                font-weight: 700;
                font-size: 16px;
            }
        }
    }
    .bg_f8{
        background: #f6f8f7;
    }
    .color_red{
        color: red;
    }
</style>
